import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';

export interface LastOrderDateResponse {
  lastOrderPlacedAt: string | null;
}

export class SubscriptionInfoService {
  static async getLastOrderDate(shopifyCustomerId: number): Promise<LastOrderDateResponse> {
    const response = await api.get(API_ENDPOINTS.CUSTOMERS.LAST_ORDER_DATE(shopifyCustomerId));
    return response.data as LastOrderDateResponse;
  }
}
